import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { codySalesJanuary2026Data } from './codySalesJanuary2026Data';
import { codySalesFebruary2026Data } from './codySalesFebruary2026Data';
import { codySalesMarch2026Data } from './codySalesMarch2026Data';
import { codySalesApril2026Data } from './codySalesApril2026Data';
import { codySalesMay2026Data } from './codySalesMay2026Data';
import { codySalesJune2026Data } from './codySalesJune2026Data';
import { codySalesJuly2026Data } from './codySalesJuly2026Data';

// REMINDER: When adding a new 2026 Cody month:
// 1. Import the new month's data above
// 2. Add it to the allMonthlyReports array below
// 3. Update the endMonth in the period object
// 4. Update the title in StandaloneCCYTD2026Report.tsx

const allMonthlyReports = [
  codySalesJanuary2026Data,
  codySalesFebruary2026Data,
  codySalesMarch2026Data,
  codySalesApril2026Data,
  codySalesMay2026Data,
  codySalesJune2026Data,
  codySalesJuly2026Data
];

const combinedData = combineReports(allMonthlyReports, 'Cody YTD Report 2026');

export const codySalesYTD2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 7,
    startMonth: 1,
    endMonth: 7,
    year: 2026,
    ytd: true
  }
};
